























































































































import Loading from 'vue-loading-overlay';
import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../../core/mixins';
import { FilterDateEvent } from '../../core/utils/types';
import { TypeFilterDate } from '../../core/models/type-filter-date';
import Axios from 'axios';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import { PageTitle } from '../../core/components';
import { SettingsService } from '../api/SettingsService';
import VariableGroup from '../components/VariableGroup.vue';
import ConfirmAction from '../../core/components/ConfirmAction.vue';
import { addItemToLocalStorage, formatDate, removeItemFromLocalStorage, StoregeKey } from '../../core/utils';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import { NormsServices } from '../../norms/api/NormsServices';
import Input from '../../core/components/Input.vue'; 
import SimpleTable from '../../core/components/SimpleTable.vue'; 
@Component({
    components: { Loading, VariableGroup, PageTitle, ConfirmAction, DeleteConfirmation, Input, SimpleTable }
})
export default class VariableGroupListPage extends Mixins(
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper
) {
    loadingMsg: string = '';
    successPost: boolean | null = null;
    pendingRequest: boolean = false;
    pendingRequestLoadingDialog: boolean = false;
    errorLoadMsg: object = {};

    selectedItemForDeletion: any = {};
    selectedItemCountVehicles: number | null = null;

    variableGroupToEdit: any = null;
    cancelToken: any | null = null;
    showConfigurationDialog: boolean = false;
    deleteJustOne: boolean = false;
    search: string = '';
    tableFilters: any = {};
    show: boolean = false;
    ids: number = 4;
    editing: boolean = false;
    sortBy: string[] = ['name'];
    sortDesc: boolean[] = [false];
    //delete confirmation
    description: boolean = false;
    is_default: boolean = false;

    variable_classifications: number[] = [];
    configure_vehicles: boolean = false;

    onlyEliminate: boolean = false;
    desconfigureVehicles: boolean = false;

    confirmationDelete: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';
    variableGroupToDelete: number = -1;

    showDeleteConfirmationDialog: boolean = false;

    deleteVariableGroupAction() {
        this.pendingRequest = true;
        let itemForDeletion: any = {
            desconfigure_vehicles: this.desconfigureVehicles
        };
        if (this.variableGroupToDelete !== -1) {
            NormsServices.deleteVariableGroupByID(this.selectedItemForDeletion.id, itemForDeletion)
                .then(response => {
                    this.$_successPatchRecipients(response.message);
                    this.pendingRequest = false;
                    this.variableGroupList = this.variableGroupList.filter(variable => {
                        return this.selectedItemForDeletion != variable;
                    });
                    this.selectedItems = [];
                })
                .catch(error => {
                    this.$_errorAddPointOfInterest(error.response.data.message);
                    this.pendingRequest = false;
                });
        }
    }

    disableDelete(item) {
        return Boolean(item.active_vehicles);
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response){
        this.$_successLoadingDialog({
            response: response
        });
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    postVariableGroup() {
        this.pendingLoadingDialog('Creando grupo de variables...');
        let variableGroup: any = {
            description: this.description,
            variable_classifications: this.variable_classifications,
            is_default: this.is_default
        };
        NormsServices.postVariableGroupList(variableGroup)
            .then(response => {
                this.$_successLoadingDialog({
                    response: response,
                    alternative_msg: 'Grupo creado con exito'
                });
                setTimeout(() => {
                    this.closeAddOrEditVariableGroup();
                }, 1200);
                this.getVariableGroupList();
            })
            .catch(error => {
                this.handleErrorAction(error, 'No se pudo crear el grupo de variables')
            });
    }

    async patchVariableGroupList() {
        this.pendingLoadingDialog('Modificando grupo de variables...');
        let variableGroup: any = {
            description: this.description,
            variable_classifications: this.variable_classifications,
            configure_vehicles: this.configure_vehicles,
            is_default: this.is_default
        };
        NormsServices.patchVariableGroupList(this.variableGroupToEdit.id, variableGroup)
            .then(response => {
                this.$_successLoadingDialog({
                    response: response,
                    alternative_msg: 'Grupo modificado con exito'
                });
                setTimeout(() => {
                    this.closeAddOrEditVariableGroup();
                }, 1200);
                this.getVariableGroupList();
            })
            .catch(error => {
                this.handleErrorAction(error, 'No se pudo modificar el grupo de variables');
            });
    }

    getVariableGroupData(variableGroupData) {
        this.description = variableGroupData.description;
        this.is_default = variableGroupData.is_default;
        this.variable_classifications = variableGroupData.variable_classifications;
        this.configure_vehicles = variableGroupData.configure_vehicles;
    }

    getRadioData(radioData) {
        this.desconfigureVehicles = radioData.desconfigure_vehicles;
    }

    closeAddOrEditVariableGroup() {
        this.show = false;
    }

    closeLoadingModal() {
        this.pendingRequest = false;
        this.successPost = null;
        this.loadingMsg = '';
    }


    resetLoadingDialog() {
        this.successPost = null;
        this.pendingRequestLoadingDialog = false;
        this.loadingMsg = '';
    }

    deleteVariableGroup(item) {
        this.getVehiclesByVariableGroupId(item);
        this.selectedItemForDeletion = item;
        this.selectedItemCountVehicles = item.active_vehicles;
        this.deleteModalTitle = 'Eliminar Grupo de variables';
        this.deleteBody =
            '¿Está seguro que desea eliminar el grupo de variables ' + '<b>"' + item['description'] + '"</b>?';
        this.variableGroupToDelete = Number(item['id']);
        this.confirmationDelete = true;
    }
    deleteAction(value) {
        if (value) {
            //si el usuario confirma
            this.confirmationDelete = false;
            this.pendingRequest = true;
            this.deleteVariableGroupAction();
        } else {
            //si le da cancelar
            this.confirmationDelete = false;
            this.variableGroupToDelete = -1;
        }
    }

    showSuccessLoadingDialog(msg) {
        this.successPost = true;
        this.loadingMsg = msg;
        setTimeout(() => {
            this.resetLoadingDialog();
        }, 1000);
    }

    showErrorLoadingDialog(error) {
        this.successPost = false;
        this.errorLoadMsg = {};
        if (error && error.response && error.response.data && error.response.data.message) {
            this.loadingMsg = 'Ocurrió un error';
            this.errorLoadMsg = error.response.data.message;
        } else {
            this.loadingMsg = 'Alerta';
            this.errorLoadMsg = error.message;
        }
    }

    format(date: string) {
        return formatDate(date);
    }

    volverAConfiguracion() {
        this.$router.push(NAME_ROUTES.SETTINGS.path);
    }

    resetFilters() {
        this.search = '';
        removeItemFromLocalStorage(StoregeKey.VARIABLE_GROUP_LIST_FILTERS)
    }

    saveFilterLocalStorage(key, value) {
        this.tableFilters[key] = value;
        addItemToLocalStorage(StoregeKey.VARIABLE_GROUP_LIST_FILTERS, this.tableFilters)
    }

    addVariableGroup() {
        this.editing = false;
        this.variableGroupToEdit = null;
        this.variableGroupDialog(true);
    }

    editVariableGroup(item) {
        this.editing = true;
        this.variableGroupToEdit = item;
        this.variableGroupDialog(true);
    }

    deleteSelectedItems() {
        this.showDeleteConfirmationDialog = true;
    }

    headersTable: any[] = [
        {
            text: 'Vehículo',
            align: 'left',
            value: 'description'
        }
    ];

    headers: any[] = [
        {
            text: 'Nombre',
            align: 'left',
            value: 'description'
        },
        {
            text: 'Fecha de creación',
            align: 'left',
            value: 'created_at',
            formatter: this.parseDate
        },
        {
            text: 'Fecha de modificación',
            align: 'left',
            value: 'updated_at',
            formatter: this.parseDate
        },
        {
            text: '#Vehículos activos',
            align: 'left',
            value: 'active_vehicles'
        },
        {
          text: 'Por defecto al crear vehículos',
          align: 'center',
          value: 'is_default'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions',
            sortable: false
        }
    ];
    variableGroupList: any[] = [];

    vehicleList: any[] = [];

    get getVariableGroups() {
        return this.variableGroupList;
    }

    selectedItems: any[] = [];

    parseDate(date: string) {
        return formatDate(date);
    }

    variableGroupDialog(value) {
        this.show = value;
    }

    close() {
        this.show = false;
        this.editing = false;
    }

    reloadTable() {
        setTimeout(() => {
            this.pendingRequest = false;
        }, 1000);
    }

    @Watch('$_getSelectedCompany')
    getVariableGroupList() {
        this.pendingRequest = true;
        if (this.$_getSelectedCompanyById != null) {
            NormsServices.getVariableGroupList()
                .then(data => {
                    this.variableGroupList = data.variablegroups;
                    this.pendingRequest = false;
                })
                .catch(err => {
                    this.pendingRequest = false;
                });
        }
    }

    getVehiclesByVariableGroupId(item) {
        this.pendingRequest = true;
        let variableGroupId = item.id;
        NormsServices.getVehiclesByVariableGroupId(variableGroupId)
            .then(data => {
                this.vehicleList = data.vehicles;
                this.pendingRequest = false;
            })
            .catch(err => {
                this.pendingRequest = false;
            });
    }

    pushUser() {
        if (!this.$_userIsSmartway) {
            this.$router.push('/');
        }
    }

    updateSearchValue(value){
        this.search = value;
    }

    mounted() {
        this.pushUser();
        this.getVariableGroupList();
    }
}
